import React from 'react'
import { InputGroup, Form } from 'react-bootstrap'
import './SpinButton.css'

const SpinButton = React.forwardRef((props, ref) => {
	return (
		<div style={props.gstyle}>
			<InputGroup className="mb-3">
				<InputGroup.Text>{props.name}</InputGroup.Text>
				<Form.Control ref={ref} {...props} type="number" className="spin-button" required/>
				{ props.unit !== undefined ?
					<InputGroup.Text min={props.min} max={props.max}>{props.unit}</InputGroup.Text> : <></>
				}
			</InputGroup>
		</div>
	)
})

export default SpinButton;
